import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestLanguageList = () => {
  const getUrl = '/user/language';

  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export default requestLanguageList;
